'use client'

import { useState } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { toast } from '@/lib/toast'
import { navigateUrl } from '@/utils/client-request'
import { isCustomerAuthActive } from '@/utils/util'
import { useCart } from './useCart'

type AddArgs = { productId: string; variantId: string; quantity: number; [key: string]: any }

export function useCartActions(vendor: any) {
  const router = useRouter()
  const pathname = usePathname()
  const { cart, addToCart } = useCart()
  const [buyNowLoading, setBuyNowLoading] = useState(false)

  const routeAfterRequiresLogin = () => {
    if (vendor?.canGuestOrder === true || !isCustomerAuthActive(vendor)) {
      router.push(navigateUrl('/checkout', pathname))
    } else {
      router.push(navigateUrl('/checkout/login', pathname))
    }
  }

  const addToCartWithRedirect = async (args: AddArgs) => {
    const result = await addToCart(args)
    if (result?.requiresLogin) routeAfterRequiresLogin()
    return result
  }

  const buyNow = async ({ productId, variantId, quantity }: AddArgs) => {
    setBuyNowLoading(true)
    try {
      const alreadyInCart = cart?.products?.some((p: any) => p.id === productId && p.variant?.id === variantId && !p.isRewardItem)
      if (alreadyInCart) {
        router.push(navigateUrl('/checkout', pathname))
        return
      }
      const result = await addToCart({ productId, variantId, quantity: quantity || 1, isBuyNow: true })
      if (result?.requiresLogin) {
        routeAfterRequiresLogin()
        return
      }
      router.push(navigateUrl('/checkout', pathname))
    } catch (error) {
      console.error('Buy now error:', error)
      toast.error('Худалдан авалтад алдаа гарлаа')
    } finally {
      setBuyNowLoading(false)
    }
  }

  return { addToCartWithRedirect, buyNow, buyNowLoading }
}
